import { getCountryByHostname } from '@/helpers/country';
import Vue, { VueConstructor } from 'vue';
import VueI18n, { LocaleMessages } from 'vue-i18n';

let vueI18n: VueI18n | undefined;

function getStartingLocale(hostname: string): string {
  const currentCountryProfile = getCountryByHostname(hostname);
  return currentCountryProfile.locale;
}

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages: LocaleMessages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

export function setupI18n(vueInstance: VueConstructor = Vue, hostname: string = window.location.hostname, 
  loadLocaleMessagesCallback: Function = loadLocaleMessages) {
  vueInstance.use(VueI18n);

  vueI18n = new VueI18n({
    locale: getStartingLocale(hostname),
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en-US',
    messages: loadLocaleMessagesCallback()
  });

  return vueI18n;
  }

export function getI18nInstance(): VueI18n {
  if (!vueI18n) {
    throw new Error('The i18n instance is not defined yet. Please call function setupI18n first.');
  }
  return vueI18n;
}

export function getI18nMultiLineContent(path: string, params: object): string[] {
  const i18n = getI18nInstance();
  const messages = i18n.t(path);

  const translatedMessages = Array.isArray(messages)
    ? messages.map((_, idx) => i18n.t(`${path}[${idx}]`, params).toString())
    : [i18n.t(path, params).toString()];

  return translatedMessages;
}
